import { Card, CardContent, CardHeader, Grid2, Grid22, Stack } from "@mui/material"
import DashboardLayout from "../../layoutcontainers/DashboardLayout"
import EditableCreatableDropdown from "../Editabledropdown"
import MaterialTypography from "../../components/MaterialTypography"
import MaterialBox from "../../components/MaterialBox"
import MaterialButton from "../../components/MaterialButton"
import axios from "axios"
import BASEURL from "../Utils/Baseurl"
import { useEffect, useState } from "react"
import { useLoading } from "../../context/loading"
import { allrolehierachy, allrolequery, allroles, creategrade, createlevel, createrolehireachy, deleterolehierachy, getallgrade, getalllevel, updategrade, updatelevel, updaterolehierachy } from "./mutation"
import Swal from "sweetalert2"
import MaterialSelect from "../../components/MasterSelect"
import Hierachytable from "./hierachytable"

const OrganizationStructure =()=>{
     const { setCirleLoading } = useLoading();
     const[alllevels,setalllevels] = useState([])

       const[allgrades,setallgrades] = useState([])
       const[allroles,setallroles] = useState([])

       const[allhierachy,setallhierachy] = useState([])
       const[hirachyid,sethierachyid] = useState(null)

       console.log(hirachyid,"h32");
       
        
       const[disabled,setdiable] = useState(true)


       //dropdown

               const[hierachydropdown,sethierachydropdown] = useState([])

         //selected hierachy and role,level,grade

            const[selectedlevel,setselectedlevel] = useState({})
      const[selectedgrade,setselectedgrade] = useState({})
       const[selectedroleandhierachy,setroleandhierachy] = useState({
         role:null,
         hierachy:null
       })
     
       console.log(selectedgrade,"selgrade");
       console.log(selectedroleandhierachy,"roleandhir");
       console.log(selectedlevel,"sellevel");
       
       
       
       






  useEffect(()=>{
    fetchalllevel()
    fetchallgrade()
    fetchallroles()
    fetchallrolehierachy()
  },[])

   useEffect(()=>{
    console.log(selectedgrade,"in useeffect");
    
    if(Object.keys(selectedgrade).length>0 && Object.keys(selectedlevel).length>0 && selectedroleandhierachy.role){
      setdiable(false)
    }
    else{
      setdiable(true)
    }

   },[selectedlevel,selectedgrade,selectedroleandhierachy])

   //fetch

        const fetchalllevel = async () => {
    setCirleLoading(true);

    try {
      let response = await axios.post(
        BASEURL,
        {
          query: getalllevel,
          
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      console.log(response?.data?.data?.allLevels,"allle");
      
        response = response?.data?.data?.allLevels.map((alllevel)=>({
            id:alllevel.id,
            label:alllevel?.levelName
        }))
      setalllevels(response)
       
    } catch (error) {
      console.log("ResponseError:", error);
    } finally {
      setCirleLoading(false);
    }
  };

       const fetchallgrade = async () => {
    setCirleLoading(true);

    try {
      let response = await axios.post(
        BASEURL,
        {
          query: getallgrade,
          
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
          response = response?.data?.data?.allGrades.map((allGrade)=>({
            id:allGrade.id,
            label:allGrade?.gradeName
        }))
      setallgrades(response)

      
    } catch (error) {
      console.log("ResponseError:", error);
    } finally {
      setCirleLoading(false);
    }
  };

         const fetchallroles = async () => {
        setCirleLoading(true);
 
        try {
          const response = await axios.post(
            BASEURL,
            {
              query: allrolequery,
            },
            {
              headers: {
                "Content-Type": "application/json",
              },
            }
          );
    
          let result = response.data.data.allRoles[0]?.data.map((role)=>({value:role?.id,label:role?.role}));
           setallroles(result)
        } catch (error) {
          console.log("error:", error);
        } finally {
          setCirleLoading(false);
        }
      };

         const fetchallrolehierachy = async () => {
        setCirleLoading(true);
 
        try {
          const response = await axios.post(
            BASEURL,
            {
              query: allrolehierachy,
            },
            {
              headers: {
                "Content-Type": "application/json",
              },
            }
          );
            let result1 = response.data.data.allRoleHierarchy
             
              
          let result = response.data.data.allRoleHierarchy?.map((hirachy)=>({value:hirachy?.id,label:hirachy?.role?.role}));
           sethierachydropdown(result)
           setallhierachy(result1)
        } catch (error) {
          console.log("error:", error);
        } finally {
          setCirleLoading(false);
        }
      };
      //create or update

      //level

    const Createlevel = async (level,setallupdatedlevels,setnewlycreatedlevel) => {
      setCirleLoading(true);
     
      let input = {
       levelName:level
      };
    
      try {
        const response = await axios.post(
          BASEURL,
          {
            query: createlevel,
            variables: input
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
  
        if (response?.data?.data?.createLevel) {
          Swal.fire({
            position: "center",
            icon: "success",
            title: "Level Created",
            showConfirmButton: false,
            timer: 2500,
          });
          setnewlycreatedlevel(response?.data?.data?.createLevel?.level)
          fetchalllevel()
          setallupdatedlevels(alllevels)
        } else {
          Swal.fire({
            position: "center",
            icon: "success",
            title: "Cant Able to Create",
            showConfirmButton: false,
            timer: 2500,
          });
        }
       
      } catch (err) {
        console.log(err);
      } finally {
        setCirleLoading(false);
      }
    };

        const Updatelevel = async (id,updatedlevel) => {
      setCirleLoading(true);
     
      let input = {
        id,
       levelName:updatedlevel
      };
    
      try {
        const response = await axios.post(
          BASEURL,
          {
            query: updatelevel,
            variables: input
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
  
        if (response?.data?.data?.updateLevel) {
          Swal.fire({
            position: "center",
            icon: "success",
            title: "Level Updated",
            showConfirmButton: false,
            timer: 2500,
          });
          fetchalllevel()
        } else {
          Swal.fire({
            position: "center",
            icon: "success",
            title: "Cant Able to Update",
            showConfirmButton: false,
            timer: 2500,
          });
        }
       
      } catch (err) {
        console.log(err);
      } finally {
        setCirleLoading(false);
      }
    };

    //grade


      const Creategrade = async (grade,setallupdatedgrades,setnewlycreatedgrade) => {
      setCirleLoading(true);
     
      let input = {
       gradeName:grade
      };
    
      try {
        const response = await axios.post(
          BASEURL,
          {
            query: creategrade,
            variables: input
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
  
        if (response?.data?.data?.createGrade) {
          Swal.fire({
            position: "center",
            icon: "success",
            title: "Grade Created",
            showConfirmButton: false,
            timer: 2500,
          });
          setnewlycreatedgrade(response?.data?.data?.createGrade?.grade)
          fetchallgrade()
          setallupdatedgrades(allgrades)
        } else {
          Swal.fire({
            position: "center",
            icon: "success",
            title: "Cant Able to Create",
            showConfirmButton: false,
            timer: 2500,
          });
        }
       
      } catch (err) {
        console.log(err);
      } finally {
        setCirleLoading(false);
      }
    };
    
        const Updategrade = async (id,updatedgrade) => {
      setCirleLoading(true);
     
      let input = {
        id,
          gradeName:updatedgrade
      };
    
      try {
        const response = await axios.post(
          BASEURL,
          {
            query: updategrade,
            variables: input
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
  
        if (response?.data?.data?.updateGrade) {
          Swal.fire({
            position: "center",
            icon: "success",
            title: "Grade Updated",
            showConfirmButton: false,
            timer: 2500,
          });
          fetchallgrade()
        } else {
          Swal.fire({
            position: "center",
            icon: "success",
            title: "Cant Able to Update",
            showConfirmButton: false,
            timer: 2500,
          });
        }
       
      } catch (err) {
        console.log(err);
      } finally {
        setCirleLoading(false);
      }
    };
    
    
     //hierachy

           const Createhierachy = async () => {
      setCirleLoading(true);

      let input =null
        if(hirachyid){
          console.log(hirachyid,"e54454");
          
          input =       {
            id:hirachyid,
  roleId: selectedroleandhierachy.role.value,
  levelId:selectedlevel?.id,
 gradeId: selectedgrade?.id,
  parentId: selectedroleandhierachy?.hierachy?.value
 }
        }
       else{
             input =
       {
  roleId: selectedroleandhierachy.role.value,
  levelId:selectedlevel?.id,
 gradeId: selectedgrade?.id,
  parentId: selectedroleandhierachy?.hierachy?.value
 }
       }
      
 
    console.log(input,"inpp");
    
      try {
        const response = await axios.post(
          BASEURL,
          {
            query:!hirachyid? createrolehireachy:updaterolehierachy,
            variables: input
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        let success =null
          if(hirachyid){
          success= response?.data?.data?.updateRoleHierarchy
          }
          else{
            success=response?.data?.data?.createRoleHierarchy
          }
      
  
        if (success) {
          Swal.fire({
            position: "center",
            icon: "success",
            title: !hirachyid ?"role hierachy Created":"role hierachy Updated",
            showConfirmButton: false,
            timer: 2500,
          });
    
        } else {
          Swal.fire({
            position: "center",
            icon: "success",
            title:! hirachyid?"Cant Able to Create":"Cant able to Update",
            showConfirmButton: false,
            timer: 2500,
          });
        }
       
      } catch (err) {
        console.log(err);
      } finally {
        setCirleLoading(false);
        fetchallrolehierachy()
      }
    };
    
 
      
   

      //handlechange

      const handleroleandhierachy =(e,name)=>{
       setroleandhierachy((prev)=>({
        ...prev,
        [name]:e
       }))

      }

      //handleview

      const handleview=(row)=>{
        console.log(row,"allroww");

        sethierachyid(row?.id)
        setselectedgrade({id:row?.grade?.id,label:row?.grade?.gradeName})
        setselectedlevel({id:row?.level?.id,label:row?.level?.levelName})
        setroleandhierachy((prev)=>(
          
          { 
            ...prev,
            hierachy:{id:row?.parent?.id,label:row?.parent?.role?.role},
           role:{ value:row?.role?.id,label:row?.role?.role}}))


        
      }


      //handledelete

      const handledelete = async(row)=>{
          try {
        const response = await axios.post(
          BASEURL,
          {
            query:deleterolehierachy,
            variables: {id:row?.id}
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        let success = response?.data?.data?.deleteRoleHierarchy
         
      
  
        if (success) {
          Swal.fire({
            position: "center",
            icon: "success",
            title: "hierachy deleted successfully",
            showConfirmButton: false,
            timer: 2500,
          });
    
        } else {
          Swal.fire({
            position: "center",
            icon: "success",
            title:"Cant Able to Delete",
            showConfirmButton: false,
            timer: 2500,
          });
        }
       
      } catch (err) {
        console.log(err);
      } finally {
        setCirleLoading(false);
        fetchallrolehierachy()
      }
      }





    

    return(
       
              <DashboardLayout>

                  <Card>
        <CardHeader
          title={
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={2}
            >
              <Stack direction="column" spacing={0}>
                <MaterialTypography variant="h5" fontWeight="medium">
                  Organization Structure
                </MaterialTypography>
              </Stack>
            </Stack>
          }
        />

          <CardContent sx={{ minHeight: "0vh" }}>
                  <MaterialBox>
                    <Grid2 container spacing={1} alignItems="center">
                      <Grid2 size={{ xs: 5, sm: 4, md: 4, lg: 4 }}>
                        <MaterialBox lineHeight={0} display="inline-block">
                          <MaterialTypography
                            component="label"
                            variant="caption"
                            fontWeight="bold"
                          >
                           Level
                          </MaterialTypography>
                        </MaterialBox>
                       <EditableCreatableDropdown
                        options={alllevels}
                        setOptions={setalllevels}
                        handlecreate={Createlevel}
                        handleedit={Updatelevel}
                        selectedOption={selectedlevel}
                        setSelectedOption={setselectedlevel}
                       
                       />
                      </Grid2>
        
                      <Grid2 size={{ xs: 5, sm: 4, md: 4, lg: 4 }}>
                        <MaterialBox lineHeight={0} display="inline-block">
                          <MaterialTypography
                            component="label"
                            variant="caption"
                            fontWeight="bold"
                          >
                            Grade
                          </MaterialTypography>
                        </MaterialBox>
                         
                            <EditableCreatableDropdown
                        options={allgrades}
                        setOptions={setallgrades}
                        handlecreate={Creategrade}
                        handleedit={Updategrade}
                        selectedOption={selectedgrade}
                        setSelectedOption={setselectedgrade}
                       
                       />

                      </Grid2>
        
                      <Grid2
                        size={{ xs: 5, sm: 4, md: 4, lg: 4 }}
                       
                      >
                        <MaterialBox lineHeight={0} display="inline-block">
                          <MaterialTypography
                            component="label"
                            variant="caption"
                            fontWeight="bold"
                          >
                            Role
                          </MaterialTypography>
                        </MaterialBox>
                             <MaterialSelect
                                           
                                          value={selectedroleandhierachy.role}
                                          onChange={(e)=>handleroleandhierachy(e,"role")}
                                          menuPortalTarget={document.body}
                                          menuPosition={"fixed"}
                                          options={allroles}
                                          // customStyles={{
                                          //   optionPadding: 2,
                                          //   optionMinWidth: 150,
                                          // }}
                                          // error={approval.approvalforStatus === "error"}
                                          // success={approval.approvalforStatus === "success"}
                                          // isLoading={isStateLoading}
                                        />

                      {/* <EditableCreatableDropdown /> */}
                      </Grid2>

                           <Grid2
                        size={{ xs: 5, sm: 4, md: 4, lg: 4 }}
                       
                      >
                        <MaterialBox lineHeight={0} display="inline-block">
                          <MaterialTypography
                            component="label"
                            variant="caption"
                            fontWeight="bold"
                          >
                            Parent
                          </MaterialTypography>
                        </MaterialBox>
                             <MaterialSelect
                                          
                                          value={selectedroleandhierachy.hierachy}
                                           onChange={(e)=>handleroleandhierachy(e,"hierachy")}
                                          menuPortalTarget={document.body}
                                          menuPosition={"fixed"}
                                          options={hierachydropdown}
                                          // customStyles={{
                                          //   optionPadding: 2,
                                          //   optionMinWidth: 150,
                                          // }}
                                          // error={approval.approvalforStatus === "error"}
                                          // success={approval.approvalforStatus === "success"}
                                          // isLoading={isStateLoading}
                                        />

                      {/* <EditableCreatableDropdown /> */}
                      </Grid2>
                    </Grid2>
                  </MaterialBox>
        
                  <MaterialBox sx={{ display: "flex", justifyContent: "end" }}>
                    <MaterialButton
                      sx={{ m: 2 }}
                      variant="gradient"
                      color="dark"
                      disabled={disabled}
                      onClick={Createhierachy}
                    >
                     Configure
                    </MaterialButton>
                  </MaterialBox>
                </CardContent>
        <Hierachytable 
        rows={allhierachy}
        onEdit={handleview}
        onDelete={handledelete}

        />


        </Card>



              </DashboardLayout>

            

    
    )
}
export default OrganizationStructure